import React, { useCallback } from 'react';
import AnimatedNavItem from './AnimatedNavItem';

const links = [
  { href: '#features', label: 'Features' },
  { href: '#how-it-works', label: 'How it Works' },
  { href: '#example-report-section', label: 'View Example Report' },
  { href: '#pricing', label: 'Pricing' }
];

export default function NavLinks() {
  const handleClick = useCallback((e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const element = document.getElementById(href.slice(1));
    if (element) {
      element.scrollIntoView({ 
        behavior: 'smooth', 
        block: 'center'
      });
      element.focus({ preventScroll: true });
    }
  }, []);

  return (
    <div className="flex flex-col md:flex-row md:items-center md:space-x-8 space-y-4 md:space-y-0">
      {links.map((link, index) => (
        <AnimatedNavItem 
          key={link.href} 
          href={link.href} 
          label={link.label} 
          index={index}
          onClick={(e) => handleClick(e, link.href)}
        />
      ))}
    </div>
  );
}